import { render } from "./AcademicResults.vue?vue&type=template&id=78dde8f3"
import script from "./AcademicResults.vue?vue&type=script&lang=js"
export * from "./AcademicResults.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__